import {Product} from "../../models/product.model";
import {
    MarketplaceFilteredProducts,
    MarketplaceFilters,
    SearchProductSortType
} from "./marketplace.state";
import {environment} from "../../../environments/environment";

// Temporary visual mock for the marketplace screen.
// To remove before production:
// 1. set `mockMarketplaceScreenEnabled` to false in `src/environments/marketplace-mock.config.ts`
// 2. delete this file and the related branches in marketplace reducer/service

export const isMarketplaceScreenMockEnabled = (): boolean => {
    return environment.mockMarketplaceScreenEnabled;
};

const buildMockProduct = (product: {
    id: string;
    name: string;
    description: string;
    productCode: string;
    price: number;
    sortOrder: number;
    family: Product["family"];
    subscriptionRecurringInterval?: number | null;
    categories?: string[];
    goals?: string[];
    isFeaturedProduct?: boolean;
    originalPrice?: number | null;
    imageUrl?: string | null;
}): Product => ({
    id: product.id,
    name: product.name,
    description: product.description,
    productCode: product.productCode,
    detail: null,
    price: product.price,
    subscriptionRecurringPeriod: product.family === 'Subscription' ? 'month' : null,
    subscriptionRecurringInterval: product.family === 'Subscription' ? (product.subscriptionRecurringInterval ?? 1) : null,
    isActive: true,
    imageUrl: product.imageUrl ?? null,
    family: product.family,
    type: 'Base',
    productFeatures: null,
    isFeaturedProduct: product.isFeaturedProduct ?? false,
    tier: null,
    sortOrder: product.sortOrder,
    serviceProvidedBy: 'Prestatore di Servizio',
    originalPrice: product.originalPrice ?? null,
    categories: product.categories ?? [],
    goals: product.goals ?? [],
});

export const MARKETPLACE_SCREEN_MOCK_PRODUCTS: Product[] = [
    buildMockProduct({
        id: '01uR200000CgocbIAB',
        name: 'Abbonamento health coaching monitorato mensile BASE',
        description: '2 sessioni/mese in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-MON-BASE',
        price: 146.4,
        sortOrder: 1,
        family: 'Subscription',
        subscriptionRecurringInterval: 1,
        categories: ['Coaching'],
        goals: ['Equilibrio'],
        imageUrl: '/assets/img/new-marketplace/test-img.jpg',
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000FUqdFIAT',
        name: 'Abbonamento health coaching monitorato semestrale BASE',
        description: '2 sessioni/mese in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-SEM-BASE',
        price: 732,
        sortOrder: 2,
        family: 'Subscription',
        subscriptionRecurringInterval: 6,
        categories: ['Coaching'],
        goals: ['Equilibrio'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000FUqgTIAT',
        name: 'Abbonamento health coaching monitorato mensile PRO',
        description: '3 sessioni/mese in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-MON-PRO',
        price: 195.2,
        sortOrder: 3,
        family: 'Subscription',
        subscriptionRecurringInterval: 1,
        categories: ['Coaching'],
        goals: ['Performance'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000FUqi5IAD',
        name: 'Abbonamento health coaching monitorato semestrale PRO',
        description: '3 sessioni/mese in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-SEM-PRO',
        price: 976,
        sortOrder: 4,
        family: 'Subscription',
        subscriptionRecurringInterval: 6,
        categories: ['Coaching'],
        goals: ['Performance'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000I0UyEIAV',
        name: 'Abbonamento health coaching monitorato trimestrale PRO',
        description: '3 sessioni/mese in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-TRI-PRO',
        price: 536.8,
        sortOrder: 5,
        family: 'Subscription',
        subscriptionRecurringInterval: 3,
        categories: ['Coaching', 'Monitoring'],
        goals: ['Performance'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000I0WtZIAV',
        name: 'Abbonamento health coaching monitorato trimestrale BASE',
        description: '2 sessioni/mese in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-TRI-BASE',
        price: 402.6,
        sortOrder: 6,
        family: 'Subscription',
        subscriptionRecurringInterval: 3,
        categories: ['Coaching', 'Monitoring'],
        goals: ['Equilibrio'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000I0fldIAB',
        name: 'Percorso nutrizione monitorata',
        description: '3 sedute in videocall da 45 minuti con nutrizionista + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-NUT-MON-PACK',
        price: 128.95,
        sortOrder: 7,
        family: 'One shot purchase',
        categories: ['Nutrizione', 'Monitoring'],
        goals: ['Nutrizione'],
        originalPrice: 149.95,
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000JBQKPIA5',
        name: 'Sessione health coaching monitorato',
        description: '1 sessione in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-SESSION',
        price: 79.3,
        sortOrder: 8,
        family: 'One shot purchase',
        categories: ['Coaching'],
        goals: ['Focus'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000KNJUfIAP',
        name: 'Seduta nutrizione monitorata',
        description: '1 seduta in videocall da 45 minuti con nutrizionista + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-NUT-MON-SESSION',
        price: 70,
        sortOrder: 9,
        family: 'One shot purchase',
        categories: ['Nutrizione'],
        goals: ['Nutrizione'],
        isFeaturedProduct: false,
    }),
    buildMockProduct({
        id: '01uR200000M4BEkIAN',
        name: 'Percorso health coaching monitorato',
        description: '3 sessioni in videocall da 45 minuti con health coach certificato + monitoraggio fisiologico condiviso con il professionista della salute',
        productCode: 'MOCK-HC-MON-PACK',
        price: 145.12,
        sortOrder: 10,
        family: 'One shot purchase',
        categories: ['Coaching', 'Monitoring'],
        goals: ['Equilibrio'],
        originalPrice: 169.2,
        isFeaturedProduct: false,
    }),
];

const sortProducts = (products: Product[], sort?: SearchProductSortType | null): Product[] => {
    return products
        .map((product, index) => ({product, index}))
        .sort((left, right) => {
            switch (sort) {
                case 'price:asc':
                    return left.product.price - right.product.price;
                case 'price:desc':
                    return right.product.price - left.product.price;
                default:
                    return compareProductsBySortOrder(left.product, right.product, left.index, right.index);
            }
        })
        .map(({product}) => product);
};

const compareProductsBySortOrder = (left: Product, right: Product, leftIndex: number, rightIndex: number): number => {
    const leftSortOrder = left.sortOrder;
    const rightSortOrder = right.sortOrder;

    if (leftSortOrder != null && rightSortOrder != null && leftSortOrder !== rightSortOrder) {
        return leftSortOrder - rightSortOrder;
    }

    if (leftSortOrder != null && rightSortOrder == null) {
        return -1;
    }

    if (leftSortOrder == null && rightSortOrder != null) {
        return 1;
    }

    return leftIndex - rightIndex;
};

const getRecurringPeriodFilterValue = (product: Product): string => {
    return `${product.subscriptionRecurringInterval ?? ''}${product.subscriptionRecurringPeriod ?? ''}`;
};

export const buildMarketplaceScreenMockAvailableFilters = (): MarketplaceFilters => ({
    categories: [
        ...new Set(
            MARKETPLACE_SCREEN_MOCK_PRODUCTS.flatMap(product => {
                const categories = product.categories ?? [];
                return categories.length > 1 ? [...categories, 'bundle'] : categories;
            })
        )
    ],
    goals: [...new Set(MARKETPLACE_SCREEN_MOCK_PRODUCTS.flatMap(product => product.goals ?? []))],
    families: [...new Set(MARKETPLACE_SCREEN_MOCK_PRODUCTS.map(product => product.family))],
    subscriptionRecurringPeriod: [
        ...new Set(
            MARKETPLACE_SCREEN_MOCK_PRODUCTS
                .filter(product => product.family === 'Subscription')
                .map(getRecurringPeriodFilterValue)
                .filter(value => value !== '')
        )
    ],
    maxPrice: [0, Math.max(...MARKETPLACE_SCREEN_MOCK_PRODUCTS.map(product => product.price), 0)],
});

export const buildMarketplaceScreenMockFilteredProducts = (
    filters: MarketplaceFilters,
    sort?: SearchProductSortType | null
): MarketplaceFilteredProducts => {
    const products = sortProducts(MARKETPLACE_SCREEN_MOCK_PRODUCTS, sort);
    const filteredProducts: MarketplaceFilteredProducts = {
        featured: [],
        bundle: [],
        subscription: [],
        oneShotPurchase: [],
        categories: {},
    };

    const maxPrice = MARKETPLACE_SCREEN_MOCK_PRODUCTS.reduce(
        (currentMaxPrice, product) => Math.max(currentMaxPrice, product.price),
        0
    );
    const filtersActive = filters.families.length > 0 ||
        filters.categories.length > 0 ||
        filters.goals.length > 0 ||
        filters.subscriptionRecurringPeriod.length > 0 ||
        filters.maxPrice[0] > 0 ||
        (filters.maxPrice[1] > 0 && filters.maxPrice[1] !== maxPrice);

    for (const product of products) {
        if (filters.categories.length > 0 && !(product.categories ?? []).some(category => filters.categories.includes(category))) {
            if (!filters.categories.includes('bundle') ||
                (filters.categories.includes('bundle') && !((product.categories ?? []).length > 1))) {
                continue;
            }
        }
        if (filters.goals.length > 0 && !(product.goals ?? []).some(goal => filters.goals.includes(goal))) {
            continue;
        }
        if (filters.families.length > 0 && !filters.families.includes(product.family)) {
            continue;
        }
        if (filters.subscriptionRecurringPeriod.length > 0 &&
            (product.family !== 'Subscription' ||
                !filters.subscriptionRecurringPeriod.includes(getRecurringPeriodFilterValue(product)))) {
            continue;
        }
        if (filters.maxPrice[0] > 0 && product.price < filters.maxPrice[0]) {
            continue;
        }
        if (filters.maxPrice[1] > 0 && product.price > filters.maxPrice[1]) {
            continue;
        }

        if (!filtersActive) {
            if (product.isFeaturedProduct || product.originalPrice) {
                filteredProducts.featured.push(product);
            }
            if ((product.categories ?? []).length > 1) {
                filteredProducts.bundle.push(product);
            }
            if (product.family === 'Subscription') {
                filteredProducts.subscription.push(product);
            }
            if (product.family === 'One shot purchase' && (product.categories ?? []).length <= 1) {
                filteredProducts.oneShotPurchase.push(product);
            }
        }

        for (const category of (product.categories ?? [])) {
            if (!filteredProducts.categories[category]) {
                filteredProducts.categories[category] = [];
            }
            filteredProducts.categories[category].push(product);
        }
    }

    return filteredProducts;
};
